<template>
  <div class="h-100 w-100 bg-login">
	 <!-- <div class="logo"  style="background-size: 100%;background-repeat: no-repeat; width: 93px;height: 51px;position: absolute;top: 20px;left:20px;z-index: 999;" >
	  	
	  </div> -->
    <div class="content-center" style="display: flex;align-items: center;justify-content: flex-end; width: 80%;margin: auto;height:47vh;min-height:440px ;">
      <div class="wrapper p-4 pt-4">
       <!-- <div v-if="loginStatus" class="corner-icon-view view-type-qrcode">
          <div class="master-login-title"></div>
          <i @click="loginStatusClick" class="iconfont icon-qrcode"></i>
         <div class="login-tip">
            <div class="poptip">
              <div class="poptip-arrow">
                <em></em>
                <span></span>
              </div>
              <div class="poptip-content">{{$t("logins.scanLogin")}}</div>
            </div>
          </div>
        </div>
        <div v-else class="corner-icon-view view-type-password">
          <div class="master-login-title"></div>
          <i @click="loginStatusClick" class="iconfont icon-password"></i>
          <div class="login-tip">
            <div class="poptip">
              <div class="poptip-arrow">
                <em></em>
                <span></span>
              </div>
              <div class="poptip-content">{{$t("logins.passwordLogin")}}</div>
            </div>
          </div>
        </div> -->
        <div class=" m-4" >
          <h1 class="text-center pb-4" style="margin: 20px 0 40px !important;">{{loginStatus?'后台密码登录':'后台扫码登录'}}</h1>
          <el-form
          style="width: 100%;"
            v-if="loginStatus"
            :model="loginForm"
            size="default"
           
            ref="loginForm"
            class="demo-ruleForm login-container mt-4 pt-4"
          >
            <el-form-item prop="account">
              <el-input
                type="text"
                v-model="loginForm.account"
                maxlength="11"
                auto-complete="off"
                :placeholder='$t("logins.phoneNull")'
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                maxlength="18"
                auto-complete="off"
                show-password
                :placeholder='$t("logins.passwordNull")'
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary " class="w-100"
                @click="loginSubmit"
				
                :loading="logining" style="margin-top: 40px;"
              >{{loginStr}}</el-button>
            </el-form-item>
          </el-form>
          <div v-else   >
            <div class="qrcode-img" style="width: 150px;height: 150px;">
              <img :src="qrcode" width="150" height="150"/>
            </div>
            <div class="qrcode-desc mt-4 text-center " style="width: 100px;">
              <i class="iconfont icon-scan"></i>
              <p class="text-left">
                {{$t("logins.open")}}
                <a href="javascript:void(0)">{{$t("logins.wechat")}}</a>
                <br />{{$t("logins.scan")}}{{$t("logins.toLogin")}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import router from "@/router";
  import {  filterAsyncRouter } from "@/router/index";
  import { listToRouter } from "../../js/common.js";
  export default {
  data() {
  
    return {
		setIntervals:'',
		qrcode:'',
      loginStatus: true,
      loginStr: this.$t('logins.login'),
      logining: false,
      loginForm: {
        account: "",
        password: ""
      },
    
    };
  },
  methods: {
	  loginStatusClick(){
		  this.loginStatus=!this.loginStatus;
		  if(this.loginStatus&&this.setIntervals){
			  clearInterval(this.setIntervals);
		  }else if(!this.loginStatus){
			  this.$axios.get(`/api/WeChat/GetWeChatQrcode`).then(e => {
			  	this.qrcode=e.url;
				let that=this;
				this.setIntervals=setInterval(er=>{
					 this.$axios.get(`/api/WeChat/GetWeChatQrcodeResult`,{params:{ElementLoading:true,str:e.str}}).then(es => {
						 console.log(es)
						 if(es){
							  clearInterval(that.setIntervals);
							  that.getPowerRoleMenu({data:es});
						 }
					 }).catch(e=>{
						  if(this.setIntervals){
						  						  this.loginStatus=true;
						  clearInterval(this.setIntervals);}
					 })
				 },3000)
				 this.$setTimeout(10*6000).then(es=>{
					 if(this.setIntervals){
						  this.loginStatus=true;
					 clearInterval(this.setIntervals);}
				 })
			    }); 
		  }
		 
	  },
	  getPowerRoleMenu(e){
		  this.$store.commit("saveToken", e.data.owinToken.access_token);
		    this.$store.commit("saveUser",  e.data.user);
		       localStorage.REFRESHTOKEN = e.data.owinToken.refresh_token||'';
		  this.$axios.get(`/api/power/GetPowerRoleMenu`).then(e => {
			  if(e.length==0){
			  	this.$message.error('当前身份没有配置权限');return
			  }
		  	 let tree = listToRouter(e, 0);
		  	 localStorage.MODULE = JSON.stringify(e);
		  	 localStorage.ROUTER = JSON.stringify(tree);
		  			 tree = filterAsyncRouter(tree); //过滤路由
		  			 router.addRoutes(tree); //动态添加路由
		  			 this.$router.replace(
		  			   this.$route.query.redirect ? this.$route.query.redirect : "/"
		  			 );
		    });  
	  },
    loginSubmit() {
		let _this=this;
		if(!this.loginForm.account){
			this.$message.error('请填写账号');return
		}
		if(!this.loginForm.password){
			this.$message.error('请填写密码');return
		}
		
	  this.$axios.post(`/api/account/PostAccountPswLogin`,this.loginForm).then(e => {
		this.getPowerRoleMenu(e);
	    });  
		return;
	let s=  [{icon:'el-icon-picture-outline-round',path:'-',name:'power',englishName:'power',id:'5a564s4da5s6d',parent:'',powerId:'456465546asd',params:''},
	{icon:'el-icon-picture-outline-round',path:'/power',name:'powers',englishName:'power',id:'5a564s4da5s6d88',parent:'5a564s4da5s6d',powerId:'456465546asd88',params:''},
	{icon:'el-icon-picture-outline-round',path:'/menu',name:'menu',englishName:'menu',id:'5a564s4dass5s6d88',parent:'',powerId:'ssa',params:''},
	{icon:'el-icon-picture-outline-round',path:'/role',name:'role',englishName:'role',id:'5a564s4dahjkss5s6d88',parent:'',powerId:'sshjka',params:''},
	{icon:'el-icon-picture-outline-round',path:'/account',name:'account',englishName:'account',id:'5a564dahjkss5s68',parent:'',powerId:'sska',params:''}];
	let tree = listToRouter(s, ""); 
	localStorage.MODULE = JSON.stringify(s);
	localStorage.TOKEN = "12312321"; 
	localStorage.ROUTER = JSON.stringify(tree);
	tree = filterAsyncRouter(tree); //过滤路由
	  router.addRoutes(tree); //动态添加路由
	  this.$router.replace(
	     "/"
	  );
	return;
    
    },
   
  }
};
</script>
<style lang="css" scoped>
@import "../.././style/login.css";
.bg-login {
  background: url(../.././assets/login-bg1.png) no-repeat center #1F1567;
      background-size: 100% 100%;
  /* background-size: auto 100vh; */
}
.logo{
	color: red;
	 /* background: url(../.././assets/logobai.png) */
}
.wrapper {
/*  position: relative; */
  width:450px !important;
  margin-left: 50%;
  left: -238px;
  height: 100%;
 /* border-radius:  10px; */
  background: rgba(255,255,255,0.3);
  /* background: rgba(255,255,255,0.2); */
 box-shadow: rgb(0 0 0 / 15%) 0px 2px 15px;
}
</style>